import React, { Fragment } from 'react';
import HighlightIcon from '../HighlightIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWalking } from '@fortawesome/free-solid-svg-icons';
import { formatDistance } from '@/utils/formatDistance';
import { InfoCircleOutlined } from '@ant-design/icons';

export default function SidePopover({
  highlights,
  facility,
  size = null,
  ...props
}) {
  const checkedHighlights = highlights.filter((highlight) => highlight.check);
  const distance = !!facility.address_distance

  return (
    <>
      <div
        className={`flex flex-col gap-3 justify-center items-start p-2 max-w-[16rem]`}
        {...props}
      >
        {checkedHighlights.map((highlight, index) => (
          <Fragment key={highlight.type + index}>
            {highlight.type === 'facility_shuttle_frequency' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <HighlightIcon
                    type="shuttle"
                    width={size === 'small' ? 22 : 38}
                    height={size === 'small' ? 22 : 38}
                    fill="#434343"
                  />
                  <span className="font-bold ml-2">Shuttle Frequency</span>
                </div>
                <p className={`text-xs md:text-sm text-left items-start`}>
                  {highlight.description && highlight.description}
                </p>
              </div>
            )}
            {highlight.type === 'facility_free_shuttles' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <HighlightIcon
                    type="free-shuttle"
                    width={size === 'small' ? 22 : 38}
                    height={size === 'small' ? 22 : 38}
                    fill="#434343"
                  />
                  <span className="font-bold ml-2">Free Shuttle</span>
                </div>
                <p className={`text-xs md:text-sm text-left items-start`}>{highlight.description && highlight.description}</p>
              </div>
            )}
            {highlight.type === 'facility_shuttle_information' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <InfoCircleOutlined className={`text-[#434343] ${size === 'small' ? "text-xl" : "text-4xl"}`} />
                  <span className="font-bold ml-2">Shuttle Information</span>
                </div>
                <p className={`text-xs md:text-sm text-left items-start`}>{highlight.description && highlight.description}</p>
              </div>
            )} 
            {highlight.type === 'facility_no_shuttles' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <HighlightIcon
                    type="no-free-shuttle"
                    width={size === 'small' ? 22 : 38}
                    height={size === 'small' ? 22 : 38}
                    fill="#434343"
                  />
                </div>
                <span className="font-bold ml-2">No Shuttle</span>

                <p className={`text-xs md:text-sm text-left items-start`}>
                  {highlight.description && highlight.description}
                </p>
              </div>
            )}
            {highlight.type === 'facility_distance' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <HighlightIcon
                    type="distance"
                    width={size === 'small' ? 22 : 38}
                    height={size === 'small' ? 22 : 38}
                    fill="#434343"
                  />
                  <span className="font-bold ml-2">Distance</span>
                </div>

                <p className={`text-xs md:text-sm text-left items-start`}>
                  {highlight.description
                    ? highlight.description
                    : `${facility.facility_airport_distance} ${facility.facility_airport_distance === 1
                      ? 'mile'
                      : 'miles'
                    }`}
                </p>
              </div>
            )}
            {highlight.type === 'facility_free_cancellation' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <HighlightIcon
                    type="free-cancellations"
                    width={size === 'small' ? 22 : 38}
                    height={size === 'small' ? 22 : 38}
                    fill="#434343"
                  />
                  <span className="font-bold ml-2">Free Cancellations</span>
                </div>

                <p className={`text-xs md:text-sm text-left items-start`}>
                  {highlight.description && highlight.description}
                </p>
              </div>
            )}
            {highlight.type === 'facility_accessibility' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <HighlightIcon
                    type="accessible"
                    width={size === 'small' ? 22 : 38}
                    height={size === 'small' ? 22 : 38}
                    fill="#434343"
                  />
                  <span className="font-bold ml-2">Wheelchair Accessible</span>
                </div>

                <p className={`text-xs md:text-sm text-left items-start`}>
                  {highlight.description && highlight.description}
                </p>
              </div>
            )}
            {highlight.type === 'facility_open_hour' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <HighlightIcon
                    type="open_hour"
                    width={size === 'small' ? 22 : 38}
                    height={size === 'small' ? 22 : 38}
                    stroke="#434343"
                  />
                  <span className="font-bold ml-2">Facility Access</span>
                </div>

                <p className={`text-xs md:text-sm text-left items-start`}>
                  {highlight.description && highlight.description}
                </p>
              </div>
            )}
            {highlight.type === 'facility_eletric_car' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <HighlightIcon
                    type="eletric_car"
                    width={size === 'small' ? 22 : 38}
                    height={size === 'small' ? 22 : 38}
                    fill="#434343"
                  />
                  <span className="font-bold ml-2">EV Charger</span>
                </div>

                <p className={`text-xs md:text-sm text-left items-start`}>
                  {highlight.description && highlight.description}
                </p>
              </div>
            )}

            {highlight.type === 'facility_additional_comments' && (
              <div className="flex flex-col justify-start items-start">
                <div className="flex flex-row">
                  <HighlightIcon
                    type="additional_comments"
                    width={size === 'small' ? 22 : 38}
                    height={size === 'small' ? 22 : 38}
                    fill="#434343"
                  />
                  <span className="font-bold ml-2">Note</span>
                </div>
                <p className={`text-xs md:text-sm text-left items-start`}>
                  {highlight.description && highlight.description}
                </p>
              </div>
            )}
          </Fragment>
        ))}
        {distance && (
          <div className="flex flex-col justify-start items-start">
            <div className="flex flex-row">
              <FontAwesomeIcon
                icon={faWalking}
                {...props}
                style={{ width: 16, height: 16 }}
              />
              <span className="font-bold ml-2">Distance</span>
            </div>

            <p className={`text-xs md:text-sm text-left items-start`}>
              {formatDistance(facility.address_distance)}
            </p>
          </div>
        )}
      </div>
    </>
  );
}
